import { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";

import Form from "./Form";
import AdminForm from "./AdminForm";
import Logo from "../../../assets/grow_logo-removebg-preview.png";

const InnerWrapper = styled.div`
  padding: 40px;
  position: relative;
  height: calc(100% - 50px);
`;

const Wrapper = styled(Box)`
  height: 100vh;
`;
export default function SelectRole({
  brands,
  businessEntityID,
  userID,
  component = "",
}) {
  const { dashboardState } = useSelector((state) => state.memberDetails);

  const role =
    useSelector((state) => state?.memberDetails.role) ||
    sessionStorage.getItem("role");

  const [userDashboardState, setUserDashboardState] = useState(
    dashboardState === "NORMAL_USER" ? dashboardState : "monetization"
  );

  const authToken =
    useSelector((state) => state?.memberDetails.authToken) ||
    sessionStorage.getItem("authToken");

  const { brandType, activeBrand } = useSelector(
    (state) => state.memberDetails
  );

  const [currentBrand, setCurrentBrand] = useState({
    ID: activeBrand.ID,
    name: activeBrand.name,
    type: activeBrand.brandType || brandType,
  });

  return (
    <Wrapper>
      <InnerWrapper>
        <Typography variant="h4">Select Brand</Typography>

        {component === "admin" ? (
          <AdminForm brands={brands} />
        ) : (
          <Form
            role={role}
            userDashboardState={userDashboardState}
            authToken={authToken}
            setUserDashboardState={setUserDashboardState}
            currentBrand={currentBrand}
            setCurrentBrand={setCurrentBrand}
            brands={brands}
            businessEntityID={businessEntityID}
            userID={userID}
          />
        )}

        <div
          className="bottom-div"
          style={{
            position: "absolute",
            bottom: "30px",
            left: 0,
            right: 0,
            display: "flex",
            justifyContent: "space-between",
            padding: "0 40px",
          }}
        >
          <div />
          <div className="footer-branding">
            <span>Powered by</span>
            <div className="growth-os-logo">
              <img
                src={Logo}
                alt="1"
                style={{ height: "25px", position: "relative", top: "-3px" }}
              />
            </div>
          </div>
        </div>
      </InnerWrapper>
    </Wrapper>
  );
}
